import {BoundCardModal} from '@yandex-delivery/bound-card/mobile'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useConfigContext} from '@yandex-delivery/order-form/src/contexts'
import React from 'react'

import {useChangePaymentCardModal} from './hooks'
import type {ChangePaymentCardModalProps as Props} from './types'

export function ChangePaymentCardModal(props: Props): React.ReactElement {
  const {paymentCard, onChange, onClose} = props
  const {fetchCardBoundContext, fetchCards, fetchBoundCard, fetchNotificationsAgreements} =
    useChangePaymentCardModal(props)
  const {countryCode} = useConfigContext()
  const i18n = useI18n()

  return (
    <BoundCardModal
      card={paymentCard}
      fetchBoundCard={fetchBoundCard}
      fetchCardBoundContext={fetchCardBoundContext}
      fetchCards={fetchCards}
      fetchNotificationsAgreements={fetchNotificationsAgreements}
      isCheckedOfferAgreement={false}
      notificationsAgreement={i18n(
        `order.notifications_agreement.title.${countryCode}`,
        '<span>Cоглашаюсь на получение рекламных сообщений и обработку моих персональных данных в целях получения рекламы от ООО “Яндекс Доставка” и <a href="https://yandex.ru/legal/affiliates/" target="_blank">Группы Яндекса</a> на условиях  <a href="https://yandex.ru/legal/confidential/" target="_blank">Политики конфиденциальности</a></span>',
      )}
      offerAgreement={i18n(
        `order.offer_agreement.title.${countryCode}`,
        'Принимаю условия <a href="https://yandex.ru/legal/delivery_tou/?lang=ru" target="_blank">оферты</a>',
      )}
      onClose={onClose}
      onSuccess={onChange}
    />
  )
}
